import { render, staticRenderFns } from "./Study.vue?vue&type=template&id=39848e3c&scoped=true&"
import script from "./Study.vue?vue&type=script&lang=ts&"
export * from "./Study.vue?vue&type=script&lang=ts&"
import style0 from "./Study.vue?vue&type=style&index=0&id=39848e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39848e3c",
  null
  
)

component.options.__file = "Study.vue"
export default component.exports